var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.05078 8.0008C1.30367 6.07154 2.251 4.30057 3.71546 3.01942C5.17992 1.73826 7.06109 1.03475 9.00685 1.04056C10.9526 1.04638 12.8295 1.76113 14.2863 3.05102C15.7431 4.34091 16.6798 6.11751 16.9212 8.04825C17.1625 9.97899 16.6919 11.9315 15.5975 13.5403C14.503 15.1491 12.8598 16.3039 10.9753 16.7885C9.09088 17.273 7.09441 17.0542 5.35966 16.173C3.6249 15.2917 2.27078 13.8084 1.55078 12.0008M1.05078 17.0008V12.0008H6.05078",
    stroke: "#2D67D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResend);
export default __webpack_public_path__ + "static/media/resend.a4025c37a5fa8f3aeeb4295015f48b61.svg";
export { ForwardRef as ReactComponent };